import { Species } from '@omniafishing/core';
import { Select } from 'antd';
import classNames from 'classnames';
import React from 'react';
import SvgAllSpecies from '../../components/svg/all_species_icon';
import { useUserPreferences } from '../../hooks/use_user_preferences';
import { WebAnalytics } from '../../lib/web_analytics';
import styles from './species_select_mobile.less';

interface SpeciesSelectProps {
  className?: string;
  onSpeciesChange?: (speciesName: string) => void;
  selectedSpecies: Species;
  speciesOptions: Species[];
}
export const SpeciesSelectMobile = (props: SpeciesSelectProps) => {
  const { className, onSpeciesChange, selectedSpecies, speciesOptions } = props;

  const { setUserPreferencesSpecies } = useUserPreferences();

  return (
    <div className={styles.selectWrapper}>
      <Select
        className={classNames(styles.speciesSelect, className)}
        value={selectedSpecies?.name ?? null}
        placeholder="Select a Species"
        onChange={(val: string) => {
          WebAnalytics.contentFiltered('species', val);
          setUserPreferencesSpecies(val);
          onSpeciesChange?.(val);
        }}
        dropdownStyle={{ minWidth: 256 }}
        options={[
          {
            label: (
              <span className={styles.selectName}>
                <SvgAllSpecies />
                All Species
              </span>
            ),
            value: null,
          },
          ...speciesOptions.map((s) => {
            return {
              label: (
                <span className={styles.selectName}>
                  <img src={s.image} alt={s.img_alt} className={styles.selectImg} />
                  {s.display_name}
                </span>
              ),
              value: s.name,
            };
          }),
        ]}
      />
    </div>
  );
};
